import { handleActions } from 'redux-actions';

import {
  ContractTypeFilterValue,
  ContractTypeFilterCount,
} from 'ha/types/SearchFilters';

import { ContractTypeFilterState } from './Types';
import { Actions } from '../constants';

const initialState = {
  listingCount: {},
  value: [],
  isHidden: false,
};

interface Payload {
  filtersCount: {
    contractType: ContractTypeFilterCount;
  };
  globalFiltersCount: {
    contractType: ContractTypeFilterCount;
  };
  contractType: ContractTypeFilterValue;
}

export default handleActions<ContractTypeFilterState, Payload>(
  {
    [Actions.LOAD_DONE]: (state, { payload }) => ({
      ...state,
      listingCount: payload.filtersCount?.contractType,
      isHidden:
        Object.values(payload.filtersCount?.contractType || {}).reduce(
          (a: number, b: number) => a + b,
          0,
        ) === 0,
    }),
    [Actions.UPDATE_SEARCH_PARAMS]: (
      state,
      { payload: { contractType = [] } },
    ) => ({
      ...state,
      value: Array.isArray(contractType) ? contractType : [contractType],
    }),
  },
  initialState,
);
